/**
 * Light and dark, chosen once and remembered.
 *
 * Defaults to the operating system's preference rather than to dark: an analyst reading
 * dense evidence tables for an afternoon has a real preference, and guessing it wrong is
 * a worse first impression than asking the platform they are already using.
 */

export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'prp.theme';

/** The theme to start in. */
export function initialTheme(): Theme {
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

/** Apply a theme to the document and remember it. */
export function applyTheme(theme: Theme): void {
  document.documentElement.classList.toggle('dark', theme === 'dark');
  window.localStorage.setItem(STORAGE_KEY, theme);
}
